import Image1 from '../assets/images/image1.jpg';
import Image2 from '../assets/images/image2.webp';
import Image3 from '../assets/images/image3.webp';
import Image4 from '../assets/images/image4.webp';

const rentItems = [
    {
        id: 1,
        title: "4 Bedroom Villa",
        address: "Raghava Veera Avenue, Poes Garden, Chennai",
        shortDescription: "Bright four bedroom house build using innovative design",
        image1: Image1,
    },
    {
        id: 2,
        title: "3 bedroom villa",
        address: "Kovalam, ECR, Chennai",
        shortDescription: "Three bedroom Beach House",
        image1: Image2,
    },
    {
        id: 3,
        address: "Sholinganallur, OMR, Chennai",
        title: "3 bedroom Villa",
        shortDescription: "Three bedroom mid-terraced house comprises of...",
        image1: Image3,
    },
    {
        id: 4,
        address: "Medavakkam, Chennai",
        title: "2 bedroom villa",
        price: "1,350",
        shortDescription: "Excellent two bedroom 2nd floor flat villah",
        image1: Image4,
    }
];

export default rentItems;